import { stripHtmlTags } from '@change-corgi/core/html';
import { useI18n } from '@change-corgi/core-react/i18n';

import { useNewsAndGuidesDetailsPageData } from '#src/app/pages/newsAndGuides/details/pageContext';

type Result = ModelHookResult<{
	categoryName: string;
	title: string;
	date: string;
	photoUrl?: string;
	mobilePhotoUrl?: string;
	photoCaption?: string;
	photoAlt?: string;
	content: string;
	styles: string;
}>;

// eslint-disable-next-line complexity
export function usePageBody(): Result {
	const {
		data: { details },
	} = useNewsAndGuidesDetailsPageData();
	const { translate } = useI18n();

	const { content, createdAtLocalized, media, title, css } = details;
	const categoryName =
		details.__typename === 'Guide' ? translate('fe.components.footer.guides') : details.mainCategory?.name || '';

	return {
		data: {
			categoryName,
			title,
			date: createdAtLocalized,
			photoUrl: media?.sizes.full?.url,
			mobilePhotoUrl: media?.sizes.medium?.url,
			photoCaption: media?.caption || undefined,
			photoAlt: (media?.caption && stripHtmlTags(media.caption)) || undefined,
			content,
			styles: css,
		},
	};
}
